export default {
  _route: {
    Home: "首页",
    Login: "登录",
    ErrorLogger: "错误日志",
    Profile: "我的主页",
    MessageCenter: "我的消息",
    Components: "组件",
    CountToDemo: "数字渐变",
    ClipperDemo: "图片裁剪",
    SplitPaneDemo: "分割窗口",
    OrgTreeDemo: "组织结构树",
    AnimationMixinDemo: "动画混入",
    DraggableListDemo: "列表拖拽",
    DraggableItemDemo: "看板拖拽",
    DraggableDialogDemo: "模态框拖拽",
    DragDrawerDemo: "抽屉拖拽",
    TinymceDemo: "富文本",
    params: "动态路由",
    query: "带参路由",
  },
  _tagsNav: {
    refresh: "刷新页面",
    close: "关闭当前",
    closeOthers: "关闭其他",
    closeAll: "关闭全部",
  },
  _headerBar: {
    changeLanguage: "修改语言成功！",
    changeSize: "修改全局 Size 成功！",
    profile: "我的主页",
    messageCenter: "我的消息",
    settings: "我的设置",
    logOut: "退出登录",
  },
  _settings: {
    layoutTitle: "布局风格配置",
    themeTitle: "主题风格设置",
    layoutComponents: "布局组件配置",
    titleMode: "浏览器标题模式配置",
    theme: "主题色",
    changeTheme: "正在修改主题色",
    showBreadcrumb: "显示面包屑",
    showTagsNav: "显示标签页",
    recordTagsNav: "缓存标签页的选项卡",
    showLayoutLogo: "显示侧边菜单 Logo",
    titleModeOne: "项目 Title + 页面 Title",
    titleModeTwo: "用户名 + 页面 Title",
    titleModeThree: "项目 Title",
    titleModeFour: "页面 Title",
    resetSettingsTitle: "重置配置",
    resetSettings: "正在清除设置缓存并刷新，请稍候...",
  },
};
